export enum $matchComponent {
  _id = '_id',
  cssSelector = 'cssSelector',
  description = 'description',
  digitalPropertyId = 'digitalPropertyId',
  image = 'image',
  imageId = 'imageId',
  imageUrl = 'imageUrl',
  thumbnailUrl = 'thumbnailUrl',
  name = 'name',
  status = 'status',
  components = 'components',
  _total = '_total',
  removeOldImage = 'removeOldImage',
  imageAltText = 'imageAltText',
  engagementMetrics = 'engagementMetrics',
  tenantId = 'tenantId',
}

export enum MatchComponentStatus {
  active = 'active',
  archived = 'archived',
}

export enum $matchComponentEngagementMetrics {
  clickCount = 'clickCount',
  clickRate = 'clickRate',
}

export const CHAR_LIMITS: Readonly<Record<string, number>> = {
  [$matchComponent.name]: 100,
  [$matchComponent.cssSelector]: 100,
  [$matchComponent.imageAltText]: 100,
};

export const COMPONENT_ATTACHMENT_MAX_SIZE_BYTES: number = 512000; // 512000 bytes = 500 KB/KiB
